import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconChevronRight24pxGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M7.41 0 4.59 2.821 13.75 12l-9.16 9.181L7.41 24l12.001-12L7.41 0Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconChevronRight24pxSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconChevronRight24pxGroup {...props} />
    </svg>
  );
};
